interface IconProps {
  color?: string
}

export const Warning = ({ color }: IconProps) => {
  return (
    <svg
      aria-hidden="true"
      width="20px"
      height="21px"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.7267 4.1875C8.73706 2.4375 11.263 2.4375 12.2733 4.1875L18.0468 14.1875C19.0572 15.9375 17.7942 18.125 15.7735 18.125H4.22651C2.20579 18.125 0.942832 15.9375 1.95319 14.1875L7.7267 4.1875ZM11.3351 4.72917C10.7417 3.70139 9.25828 3.70139 8.66489 4.72917L2.89139 14.7292C2.298 15.7569 3.03974 17.0417 4.22651 17.0417H15.7735C16.9603 17.0417 17.702 15.7569 17.1086 14.7292L11.3351 4.72917Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 7.04167C10.2992 7.04167 10.5417 7.28418 10.5417 7.58333V12.1667C10.5417 12.4658 10.2992 12.7083 10 12.7083C9.70086 12.7083 9.45835 12.4658 9.45835 12.1667V7.58333C9.45835 7.28418 9.70086 7.04167 10 7.04167Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.625 14.875C10.625 15.2202 10.3452 15.5 10 15.5C9.65484 15.5 9.37501 15.2202 9.37501 14.875C9.37501 14.5298 9.65484 14.25 10 14.25C10.3452 14.25 10.625 14.5298 10.625 14.875Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
